import { Helmet } from 'react-helmet-async';
import AccountEditView from 'src/sections/taikhoan/view/account-edit-view';
// sections

// ----------------------------------------------------------------------

export default function AccountEditPage() {
  return (
    <>
      <Helmet>
        <title> Quản trị: Chỉnh sửa tài khoản</title>
      </Helmet>

      <AccountEditView />
    </>
  );
}
